import { Controller, useFormContext } from 'react-hook-form';
import { Box, Checkbox, FormControlLabel, InputLabel, Text, Tooltip } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';

import { ISAideStatusRide } from './types';

interface AideStatusProps {
  isPaused?: boolean;
  isMustBeMet?: boolean;
}

export const AideStatus: React.FC<AideStatusProps> = ({ isPaused, isMustBeMet }) => {
  const { control } = useFormContext<ISAideStatusRide>();

  const getDisabledTooltip = () => {
    let reason = '';

    if (isPaused) {
      reason = 'is paused';
    } else if (isMustBeMet) {
      reason = 'must be met';
    }

    return reason ? `This checkbox is disabled because the rider ${reason}` : '';
  };

  return (
    <Box display="flex" gap="36px" alignItems="stretch" width="100%">
      <Box display="flex" gap="24px" alignItems="center" width="calc(50% - 18px)" flexShrink={0}>
        <InputLabel style={{ width: '101px', minWidth: '101px', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
          Aide Status
        </InputLabel>
        <FormControlLabel
          label={'This rider is an Aide'}
          labelPlacement="end"
          control={
            <Controller
              control={control}
              name="isAide"
              render={({ field: { onChange, value } }) => (
                <Tooltip title={getDisabledTooltip()}>
                  <span>
                    <Checkbox
                      data-testid="aide-status-checkbox"
                      color="primary"
                      disabled={isPaused || isMustBeMet}
                      checked={value}
                      onChange={(e) => {
                        onChange(e.target.checked);
                      }}
                    />
                  </span>
                </Tooltip>
              )}
            />
          }
        />
      </Box>
      <Box flex={1} display="flex" alignItems="stretch">
        <Text
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '24px',
            width: '100%',
            background: colorTokens.background.light,
          }}
        >
          Set aide flag when this rider is not a student or the primary passenger, and is only on the ride to accompany
          the primary passenger(s). When the aide is the last remaining rider on the ride, RideIQ will automatically
          cancel the ride.
        </Text>
      </Box>
    </Box>
  );
};
